
export function stateGetter(state) {
    return state
}

